const srcIsGif = src => {
  return /\.(gif)$/i.test(src);
};

const checkImgSrcIsGif = src => {
  // const updatedSrc = srcIsGif(src) ? `${src}?a=${Math.random()}` : src;

  const updatedSrc = /\.(gif)$/i.test(src) ? `${src}?a=${Math.random()}` : src;
  return updatedSrc;
};

export default checkImgSrcIsGif;
export { srcIsGif };
